import { useState, useEffect, useLayoutEffect } from "react";
import { AxiosInstance } from "axios";

import StorageUtil from "../../utils/storageUtil";
import { authProps } from "../../utils/viewUtility";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LOG_OUT } from "../../modules/auth/store/actionTypes";
import routePath from "routes/routePaths";

const useAxios = (httpClient: AxiosInstance) => {
	const location = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [isLoading, setLoader] = useState(false);
	const [isServerError, setServerError] = useState(false);

	useEffect(() => {
		setServerError(false);
	}, [location]);

	useLayoutEffect(() => {
		const reqInterceptor = httpClient.interceptors.request.use((req: any) => {
			if (!req.config ?? !req.config.noLoader) {
				setLoader(true);
			}
			if (req.config?.[authProps.NO_HEADER]) return req;
			const token = StorageUtil.getData(authProps.SECURITY_TOKEN);
			const userKey = StorageUtil.getObject(authProps.USER_DATA);
			if (token) {
				req.headers[authProps.SECURITY_TOKEN] = token;
				req.headers[authProps.USER_KEY] = userKey.id;
			}
			return req;
		});

		const resInterceptor = httpClient.interceptors.response.use(
			(res) => {
				if (res) {
					setServerError(false);
				}
				setLoader(false);

				if (res?.data?.error?.errorCode === "INVALID_TOKEN") {
					StorageUtil.removeAll();
					dispatch({ type: LOG_OUT });
					navigate(routePath.LOGIN);
				}
				return res;
			},
			(error) => {
				setLoader(false);
				if (error.response && (error.response.status === 400 || error.response.status > 401)) {
					setServerError(true);
				}
			}
		);

		return () => {
			httpClient.interceptors.request.eject(reqInterceptor);
			httpClient.interceptors.response.eject(resInterceptor);
		};
	}, []);

	return [isLoading, isServerError];
};

export default useAxios;
